import styles from './ParcellingTable.module.css';

export interface ParcellingTableRow {
	month: string;
	phase: string;
	n: number | string;
	p: number | string;
	k: number | string;
	ca: number | string;
	mg: number | string;
	s: number | string;
	b: number | string;
	cu: number | string;
	fe: number | string;
	mn: number | string;
	zn: number | string;
	isTotal?: boolean;
}

export interface ParcellingTableProps {
	rows: ParcellingTableRow[];
}

const NUTRIENT_COLS = [
	{ key: 'n', label: 'N' },
	{ key: 'p', label: 'P₂O₅' },
	{ key: 'k', label: 'K₂O' },
	{ key: 'ca', label: 'Ca' },
	{ key: 'mg', label: 'Mg' },
	{ key: 's', label: 'S' },
	{ key: 'b', label: 'B' },
	{ key: 'cu', label: 'Cu' },
	{ key: 'fe', label: 'Fe' },
	{ key: 'mn', label: 'Mn' },
	{ key: 'zn', label: 'Zn' },
] as const;

export const ParcellingTable = ({ rows }: ParcellingTableProps) => (
	<div className={styles.wrapper}>
		<table className={styles.table}>
			<thead>
				<tr>
					<th className={styles.headerCell}>MÊS</th>
					<th className={styles.headerCell}>FASE</th>
					{NUTRIENT_COLS.map((col) => (
						<th key={col.key} className={styles.headerCell}>
							{col.label}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{rows.map((row, idx) => (
					<tr
						key={`${row.month}-${idx}`}
						className={`${styles.row} ${row.isTotal ? styles.totalRow : ''}`}
					>
						<td className={styles.monthCell}>{row.month}</td>
						<td className={styles.phaseCell}>{row.phase}</td>
						{NUTRIENT_COLS.map((col) => (
							<td key={col.key} className={styles.nutrientCell}>
								{row[col.key]}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);
